import { CoverageBlock, TeamCoverageEntry } from './coverageHoursTeamUtils';
import { minutesOfDay } from './coverageHoursTimeUtils';

function blockSignature(block: CoverageBlock): string {
  const days = [...block.daysOfWeek].sort().join(',');

  return `${days}|${minutesOfDay(block.startTime)}|${minutesOfDay(
    block.endTime,
    block.startTime
  )}`;
}

// The entry id is a client-side uuid regenerated on every load, so the signature
// is built from the team and the normalised blocks only.
function teamSignature(entry: TeamCoverageEntry): string {
  const blocks = entry.coverageBlocks.map(blockSignature).sort().join(';');

  return `${entry.teamId}=>${blocks}`;
}

function contentKey(teams: TeamCoverageEntry[]): string {
  return teams.map(teamSignature).sort().join('\n');
}

export function hasCoverageHoursChanges(
  initialTeams: TeamCoverageEntry[],
  currentTeams: TeamCoverageEntry[]
): boolean {
  return contentKey(initialTeams) !== contentKey(currentTeams);
}
